// Eventos de analytics — respeitam o consentimento e NUNCA enviam dados pessoais.
function analyticsAllowed() {
  try {
    const c = JSON.parse(localStorage.getItem('mp_cookie_consent_v2') || 'null');
    return !!(c && c.categories && c.categories.analytics);
  } catch {
    return false;
  }
}

// Consentimento de publicidade (Google Ads / conversões).
function adsAllowed() {
  try {
    const c = JSON.parse(localStorage.getItem('mp_cookie_consent_v2') || 'null');
    return !!(c && c.categories && c.categories.ads);
  } catch {
    return false;
  }
}

// Modo debug do GA4 (DebugView): ?ga_debug=1 ou localStorage mp_ga_debug=1.
function isDebug() {
  try {
    return (
      window.location.search.includes('ga_debug=1') ||
      localStorage.getItem('mp_ga_debug') === '1'
    );
  } catch {
    return false;
  }
}

// Mapeia eventos internos para os nomes-padrão do GA4 (para conversões/Ads).
const GA4_ALIAS = {
  send_contact: 'generate_lead',
  start_checkout: 'begin_checkout',
  view_vehicle: 'view_item',
  share_listing: 'share',
};

// Remove qualquer campo potencialmente pessoal antes de enviar.
const BLOCKED = ['email', 'telefone', 'phone', 'nome', 'name', 'mensagem', 'message', 'matricula'];
function sanitize(params = {}) {
  const out = {};
  Object.keys(params).forEach((k) => {
    if (!BLOCKED.includes(k.toLowerCase()) && params[k] != null) out[k] = params[k];
  });
  return out;
}

export function track(event, params = {}) {
  if (!analyticsAllowed()) return;
  const clean = sanitize(params);
  if (isDebug()) {
    clean.debug_mode = true;
    // eslint-disable-next-line no-console
    console.debug('[analytics] event:', event, clean);
  }
  try { if (typeof window.gtag === 'function') window.gtag('event', event, clean); } catch (_) {}
  const alias = GA4_ALIAS[event];
  try { if (alias && typeof window.gtag === 'function') window.gtag('event', alias, clean); } catch (_) {}
  try { if (window.posthog && window.posthog.capture) window.posthog.capture(event, clean); } catch (_) {}
}

// Conversão de COMPRA — chamar SÓ quando o pagamento está confirmado pelo backend.
// Dispara GA4 `purchase` (consentimento analytics) + conversão Google Ads (consentimento ads).
export function trackPurchase({ transactionId, value, currency = 'EUR', items } = {}) {
  const debug = isDebug();
  const gaParams = {
    transaction_id: transactionId,
    value: Number(value) || 0,
    currency,
    ...(items ? { items } : {}),
    ...(debug ? { debug_mode: true } : {}),
  };
  if (debug) {
    // eslint-disable-next-line no-console
    console.debug('[analytics] purchase:', gaParams);
  }
  if (analyticsAllowed()) {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'purchase', gaParams); } catch (_) {}
    try { if (window.posthog && window.posthog.capture) window.posthog.capture('purchase', { value: gaParams.value, currency }); } catch (_) {}
  }
  if (adsAllowed()) {
    const adsId = window.__MP_ADS_ID;
    const label = window.__MP_ADS_PURCHASE_LABEL;
    const sendTo = adsId ? (label ? `${adsId}/${label}` : adsId) : null;
    if (sendTo) {
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'conversion', {
            send_to: sendTo,
            value: gaParams.value,
            currency,
            transaction_id: transactionId,
            ...(debug ? { debug_mode: true } : {}),
          });
        }
      } catch (_) {}
    }
  }
}
